import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EditorImg from 'lowcode/components/EditorImg';
import IconArr from './IconArr';
import Modal from './components/Modal';
import EcoFaqWithImg from 'eco-design/sections/eco-faq-win-img';
import { useState } from 'react';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.FAQ');
    const [activeIndex, setActiveIndex] = useState<number | null>(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const list = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873519756/a1.jpg',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873538829/a2.jpg',
        },
        {
            title: t('item3_title'),
            desc: t('item3_desc'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873575882/a5.jpg',
        },
        {
            title: t('item4_title'),
            desc: t('item4_desc'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873550423/a3.jpg',
        },
        {
            title: t('item5_title'),
            desc: t('item5_desc'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873562581/a4.jpg',
        },
        {
            title: t('item6_title'),
            desc: t('item6_desc'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873588142/a6.jpg',
        },
        {
            title: t('item7_title'),
            desc: t('item7_desc'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873600226/a7.jpg',
        },
        {
            title: t('item8_title'),
            desc: t('item8_desc'),
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718873613416/a8.jpg',
        },
    ];

    const mouseEnterHandle = (index: number) => {
        setActiveIndex(index);
    };

    return (
        <div className={styles.comp} id="FAQ">
            <EcoSpace />
            <EcoTitle title={t('title')} className="faq-title" />
            <EcoSpaceSmall />
            <div className="dp3-container">
                <div className="dp3-inter">
                    <div className="faq-r"></div>
                    <div className="faq-l">
                        {list.map((item: any, index: number) => {
                            if (!item.title || !item.desc) {
                                return null;
                            }
                            return (
                                <div
                                    key={index}
                                    className={`faq-item${activeIndex === index ? ' faq-item-active' : ''}`}
                                    onClick={() => mouseEnterHandle(index)}
                                >
                                    <div className="faq-item-title">
                                        {item.title}
                                        <IconArr />
                                    </div>
                                    <div className="faq-item-desc">
                                        <div>{item.desc}</div>
                                        {index === 0 && <div className="faq-item-tips">{t('item1_tips')}</div>}
                                        {index === 0 && (
                                            <div className="faq-item-btn" onClick={() => setIsModalOpen(true)}>
                                                {t('item1_btn_text')}
                                                <span className="faq-item-btn-arrow"></span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="faq-item-img">
                                        <EditorImg pc={item.pc} />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <Modal visible={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className="faq-modal-content">
                    {/* <div className="faq-modal-text">
                        <h3 className="faq-modal-subtitle">{list[0].title}</h3>
                        <p className="faq-modal-desc">{list[0].desc}</p>
                    </div> */}
                    <div className="faq-modal-image">
                        <EditorImg pc="https://websiteoss.ecoflow.com/upload/image/1745917605447/modal_img.jpg" />
                    </div>
                </div>
            </Modal>
        </div>
    );
}
